// The server renders `<meta name="description">` per URL (ThreeDStudioController#studio_meta_description);
// client-side navigation only pushes history state, so the tag is rewritten in place here.
export const setMetaDescription = (content) => {
  if (typeof document === 'undefined') return

  document.querySelector('meta[name="description"]')?.setAttribute('content', content)
}

export default setMetaDescription
